import {
    UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_REQUEST,
    updateProcessStatementCommentVisibilitySuccess,
    updateProcessStatementCommentVisibilityFailure,
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { message } from "antd";

export function updateProcessStatementCommentVisibilityEpic(action$, store$, { ProcessStatementRepository }) {
    return action$.pipe(
        ofType(UPDATE_PROCESS_STATEMENT_COMMENT_VISIBILITY_REQUEST),
        mergeMap( action => from(ProcessStatementRepository.updateCommentVisibility(action.payload.modules))
            .pipe(
                mergeMap( ({ year, modules }) => {
                    message.success('Sichtbarkeit der Kommentare wurde erfolgreich angepasst.');
                    return from ([
                        updateProcessStatementCommentVisibilitySuccess({ year, modules }),
                    ]);
                }),
                catchError( error => {
                    return from([
                        updateProcessStatementCommentVisibilityFailure(error),
                    ])
                })
            )
        ),
    );
}
